import {
  warehouseOptionsSelector,
  warehouseOptionTokensSelector,
} from '../../../../data/warehouses.js'
import {useSelector} from '../../../../store.js'
import FilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/FilterPanel.js'
import {
  modalFormSelector,
  updateModalForm,
  RECEIVING_WAREHOUSE_FILTER_PANEL,
} from './transferListFilterModalFunctions.js'

export default function ReceivingWarehouseFilterPanel() {
  const form = useSelector(modalFormSelector)
  const warehouseOptions = useSelector(warehouseOptionsSelector)
  const warehouseOptionTokens = useSelector(warehouseOptionTokensSelector)

  return (
    <FilterPanel
      id={RECEIVING_WAREHOUSE_FILTER_PANEL}
      label="Receiving Warehouses"
      searchPlaceholder="Search for a warehouse filter..."
      options={warehouseOptions}
      optionTokens={warehouseOptionTokens}
      selected={form.receiving_warehouse_id}
      onSelect={(option) => {
        const receiving_warehouse_id = form.receiving_warehouse_id.filter(
          (id) => id !== option.value,
        )

        if (
          receiving_warehouse_id.length === form.receiving_warehouse_id.length
        ) {
          receiving_warehouse_id.push(option.value)
        }

        updateModalForm({receiving_warehouse_id})
      }}
    />
  )
}
